// import Setting from "@container/setting";
import AuthLayout from "@container/layout/auth";
import TrainingAuthLayout from "@container/layout/training-auth";
import OuraAuthLayout from "@container/layout/oura-auth";
import SettingV2 from "@container/setting-v2";
import { useUserProfileContext } from "@context/user_profile";
import { useOuraWorkspace } from "@oura/role";

export default function SettingsPage() {
    // Each product keeps its own sidebar on the shared Settings page. Training
    // and Oura have their own nav (AuthLayout wouldn't know their roles and
    // would render an empty sidebar). Oura is detected by the shared
    // detector: JWT role only in production, ?product=oura hint honored in
    // dev/staging (where the backend doesn't emit Oura roles yet).
    const [, userInfo] = useUserProfileContext();
    const { isOuraWs: isOura } = useOuraWorkspace();
    const isTrainer = userInfo?.role === "training-agent" && userInfo?.company_type === "training-agent";

    const Layout = isOura ? OuraAuthLayout : isTrainer ? TrainingAuthLayout : AuthLayout;
    return (
        <Layout>
            <SettingV2 />
        </Layout>
    );
}
